export default __webpack_public_path__ + "static/media/guide_dev_03.0d1ec0bf.md";